import React from 'react'
import Chart from "react-apexcharts";

function MonthlyBarChart({chartData}) {
  var chartOption = {
    series: [
      {
        name: "최대",
        data: chartData.maxTotal,
      },
      {
        name: "평균",
        data: chartData.avgTotal,
      },
      {
        name: "10%절사 최대",
        data: chartData.maxTrunc,
      },
      {
        name: "10%절사 평균",
        data: chartData.avgTrunc,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "65%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
          // dataLabels: {
          //   total: {
          //     enabled: true,
          //     style: {
          //       fontSize: "13px",
          //       fontWeight: 900,
          //     },
          //   },
          // },
        },
      },
      dataLabels: {
        enabled: true,
        // formatter: function (val) {
        //   return val + "%";
        // },
        // offsetY: -20,
        formatter : function(val) {
          if (parseInt(val) >= 1000) {
              return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // 천단위 콤마
          } else {
              return val.toString();
          }
        },
        offsetY: -18,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        labels: {
          style: {
            fontSize: "10px",
          },
          rotate: -0,
        },
        categories: [
          ["이벤트 발생 건수", "(1대/1일)"],
          ["주행 건수(주차 포함)", "(1대/1일)"],
          ["저장 영상 수", "(1대1일)"],
          ["저장 영상 용량(GB)", "(1대/1일)"],
          ["라이브 뷰 시간(분)", "(1대/1일)"],
          ["라이브 뷰 횟수", "(1대/1일)"],
          ["저장 영상 재생 횟수", "(1대/1일)"],
        ],
      },
      yaxis: {
        title: {
          // stext: "$ (thousands)",
        },
        labels: {
          // formatter: function (val) {
          //   return val.toFixed(0);
          // },
          formatter : function(val) {
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // 천단위 콤마
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          show: true,
          formatter: function (val) {
            if (parseInt(val) >= 1000) {
              return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // 천단위 콤마
            } else {
              return val.toString();
            }
          },
        },
      },
    },
  };

  return (
    <div
      id="chart"
      style={{ width: "100%", border: "1px solid #9e9e9e", marginTop: "10px" }}
    >
      <Chart
        options={chartOption.options}
        series={chartOption.series}
        type="bar"
        height={400}
        // width={1100}
      />
    </div>
  );
}

export default MonthlyBarChart